import React from 'react';

const SvgBasket = props => (
  <svg id="icon" width="38" viewBox="0 0 38.656 42" {...props}>
    <defs>
      <style>
        {`.cls-1,.cls-2{fill:none;stroke:${
          props.color
        };stroke-width:2px}.cls-1{fill-rule:evenodd}`}
      </style>
    </defs>
    <path
      id="\u041F\u0440\u044F\u043C\u043E\u043A\u0443\u0442\u043D\u0438\u043A_\u0456\u0437_\u0437\u0430\u043E\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u043C\u0438_\u043A1"
      data-name="\u041F\u0440\u044F\u043C\u043E\u043A\u0443\u0442\u043D\u0438\u043A \u0456\u0437 \u0437\u0430\u043E\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u043C\u0438 \u043A1"
      className="cls-1"
      d="M938.034 2030h31.348c1.675 0 2.849 1.63 2.625 3.59l-2.723 23.91a2.857 2.857 0 0 1-2.764 2.5H940.9a2.858 2.858 0 0 1-2.765-2.5l-2.722-23.91c-.228-1.96.945-3.59 2.621-3.59z"
      transform="translate(-934.375 -2019)"
    />
    <circle
      id="\u0415\u043B\u0456\u043F\u0441_12"
      data-name="\u0415\u043B\u0456\u043F\u0441 12"
      className="cls-2"
      cx={12.625}
      cy={17}
      r={3}
    />
    <circle
      id="\u0415\u043B\u0456\u043F\u0441_12_\u043A\u043E\u043F\u0456\u044F"
      data-name="\u0415\u043B\u0456\u043F\u0441 12 \u043A\u043E\u043F\u0456\u044F"
      className="cls-2"
      cx={26.625}
      cy={17}
      r={3}
    />
    <path
      id="\u0424\u0456\u0433\u0443\u0440\u0430_5"
      data-name="\u0424\u0456\u0433\u0443\u0440\u0430 5"
      className="cls-1"
      d="M946 2035v-11s-.01-4 4-4h8s4 .12 4 4v11"
      transform="translate(-934.375 -2019)"
    />
  </svg>
);

export default SvgBasket;
